export const NEW_PRO_ROW_CLASS = 'bg-blue-100 dark:bg-blue-900/30';
export const STORAGE_CLEARED_ROW_CLASS = 'bg-purple-100 dark:bg-purple-900/30';
// IMPORT PRO with no weight — can't be finalized until the LC enters one.
export const MISSING_WEIGHT_ROW_CLASS = 'bg-red-50 dark:bg-red-900/20';

interface SchedulingRowColorFields {
  pronumber: number;
  storage_cleared_date: string | null;
  // Set by the backend when the PRO has a live storage Additional Cost record
  // with at least one line item marked paystatus 'PAY'.
  has_storage_addl_cost?: boolean;
  // Set by the backend only for IMPORT PROs whose lbs is NULL/0
  // (scheduling_service leg queries).
  is_missing_weight?: boolean;
  // Set by the backend only for Haz=Y PROs with no HAZ-MAT PAPERWORK document.
  is_missing_haz_docs?: boolean;
}

// Newly-arrived blue outranks storage-cleared purple (per scheduling team);
// both outrank the missing-weight red, which is a per-row warning rather than a
// workflow state and also shows as a "NO WT" pill in the flags column.
export function getSchedulingRowClassName(
  row: SchedulingRowColorFields,
  newPronumbers: ReadonlySet<number>,
): string {
  if (newPronumbers.has(row.pronumber)) return NEW_PRO_ROW_CLASS;
  // Purple needs BOTH a cleared date and a storage Additional Cost record with
  // a PAY line item — a cleared PRO with no payable storage charge on it isn't
  // worth flagging.
  const cleared = row.storage_cleared_date;
  if (cleared && cleared !== '0000-00-00' && row.has_storage_addl_cost) {
    return STORAGE_CLEARED_ROW_CLASS;
  }
  // Both finalize blockers share the same red tint; the Flags pill says which.
  if (row.is_missing_weight || row.is_missing_haz_docs) return MISSING_WEIGHT_ROW_CLASS;
  return '';
}
